export default __webpack_public_path__ + "a07b308b3c7eab4c2efb9fa0a99858ca.svg";